import type { StoreHit } from '@/integrations/algolia/types';

export const getLangSlugForAlgolia = (langSlug: string) => {
  if (langSlug === 'zh') {
    return 'zh_Hans';
  }
  if (langSlug === 'zht') {
    return 'zh_Hant';
  }
  return langSlug;
};

export const getTranslatedStoreValue = <T extends StoreHit, K extends keyof T>(
  hit: T | undefined | null,
  key: K,
  langSlug: string,
) => {
  if (!hit) {
    return '';
  }
  const objectKey = `${String(key)}_${getLangSlugForAlgolia(
    langSlug,
  )}` as keyof T;
  const value = hit[objectKey] as string;

  if (value) {
    return value;
  }

  return hit[key] ?? '';
};
